"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Formatter: true,
  Tokenizer: true,
  expandPhrases: true
};
Object.defineProperty(exports, "Formatter", {
  enumerable: true,
  get: function get() {
    return _Formatter["default"];
  }
});
Object.defineProperty(exports, "Tokenizer", {
  enumerable: true,
  get: function get() {
    return _Tokenizer["default"];
  }
});
Object.defineProperty(exports, "expandPhrases", {
  enumerable: true,
  get: function get() {
    return _expandPhrases.expandPhrases;
  }
});

var _sqlFormatter = require("./sqlFormatter");

Object.keys(_sqlFormatter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _sqlFormatter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sqlFormatter[key];
    }
  });
});

var _Formatter = _interopRequireDefault(require("./formatter/Formatter"));

var _Tokenizer = _interopRequireDefault(require("./lexer/Tokenizer"));

var _expandPhrases = require("./expandPhrases");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
//# sourceMappingURL=index.js.map